import script from "./PatientEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./PatientEditModal.vue?vue&type=style&index=0&id=21e86266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e86266"]])

export default __exports__